"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowButton = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var RowButton = exports.RowButton = _styledComponents["default"].div.withConfig({
  displayName: "RowButton",
  componentId: "sc-xxkq4e-0"
})(["position:absolute;z-index:0;inset:0;cursor:pointer;background-color:transparent;border:none;width:100%;&:focus{outline:none;}&[disabled],&[aria-disabled='true'],fieldset[disabled] &{", "}"], _index.buttonStylesDisabled);